import { render, staticRenderFns } from "./AlibiTrackForm.vue?vue&type=template&id=2dbf752e&scoped=true"
import script from "./AlibiTrackForm.vue?vue&type=script&lang=js"
export * from "./AlibiTrackForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf752e",
  null
  
)

export default component.exports